import {
    AlertDialogContent,
    AlertDialogOverlay,
} from "@radix-ui/react-alert-dialog";
import styled, { keyframes } from "styled-components";

const overlayShow = keyframes`
    from{ opacity: 0 };
    to { opacity: .5 };
`;

const contentShow = keyframes`
    from { opacity: 0; transform: translate(-50%, -48%) scale(.96) };
    to { opacity: 1; transform: translate(-50%, -50%) scale(1) };
    `;

export const Content = styled(AlertDialogContent)`
    z-index: 999999999999999999999;
    position: fixed;
    width: 25rem;
    top: 50%;
    left: 50%;
    background-color: white;
    border-radius: 6px;
    box-shadow: hsl(206 22% 7% / 35%) 0px 10px 38px -10px,
        hsl(206 22% 7% / 20%) 0px 10px 20px -15px;
    transform: translate(-50%, -50%);
    max-height: 85vh;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 2rem;

    @media (prefers-reduced-motion: no-preference) {
        animation: ${contentShow} 150ms cubic-bezier(0.16, 1, 0.3, 1) forwards;
    }
    :focus {
        outline: "none";
    }
`;

export const Overlay = styled(AlertDialogOverlay)`
    background-color: ${({ theme }) => theme.gray50};
    opacity: 0.7;
    position: fixed;
    inset: 0;
    @media (prefers-reduced-motion: no-preference) {
        animation: ${overlayShow} 150ms cubic-bezier(0.16, 1, 0.3, 1) forwards;
    }
`;

export const TextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

export const ButtonWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 1rem;

    button.alert-cancel,
    button.alert-proceed {
        padding: 0 1rem;
    }
`;

export const Title = styled.h1`
    font-style: normal;
    font-weight: 800;
    font-size: 0.875rem;
    line-height: 1.125rem;
    color: ${({ theme }) => theme.purple600};
`;

export const Description = styled.p`
    font-style: normal;
    font-weight: 400;
    font-size: 1rem;
    line-height: 1.375rem;
    color: ${({ theme }) => theme.gray600};
`;
